export const CIRCLE_PLAYSTORE_URL = "https://circle.so/android";

export const PLAYSTORE_BASE_URL =
  "https://play.google.com/store/apps/details?id=";
